import { render, staticRenderFns } from "./utilizing.vue?vue&type=template&id=5229aee6&scoped=true&"
import script from "./utilizing.vue?vue&type=script&lang=js&"
export * from "./utilizing.vue?vue&type=script&lang=js&"
import style0 from "./utilizing.vue?vue&type=style&index=0&id=5229aee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5229aee6",
  null
  
)

export default component.exports